import ViewSearchResults from "@/components/ViewSearchResults/viewSearchResults.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";
import { AllURLSearchFilterValues } from "@/types";
import { extractURLFilters } from "@/utils/taskSearch.util";
import cloneDeep from "lodash.clonedeep";
import isEqual from "lodash.isequal";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";

const SearchResultsPage = () => {
  const location = useLocation();

  const [filters, setFilters] = useState<AllURLSearchFilterValues | null>(null);
  // Memoize urlParams to prevent unnecessary re-renders
  const urlParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  useEffect(() => {
    const newFilters = extractURLFilters(urlParams);
    console.log("New filters", newFilters);

    if (newFilters === "error") {
      console.error("Error parsing URL filters");
      setFilters(null);
      return;
    }

    const deepCloneFilters = cloneDeep(filters);
    const deepCloneNewFilters = cloneDeep(newFilters);
    if (!isEqual(deepCloneFilters, deepCloneNewFilters)) {
      console.log(
        "Filters are not equal",
        deepCloneFilters,
        deepCloneNewFilters
      );
      setFilters(newFilters);
    }
  }, [urlParams, filters]);

  useEffect(() => {
    console.log(urlParams);
  }, [urlParams]);

  useEffect(() => {
    console.log(filters);
  }, [filters]);

  return (
    <BasePage currPage="search">
      <Card className="flex flex-col w-full h-full flex-grow rounded-sm dark:bg-background">
        {filters && <ViewSearchResults URLFilters={filters} />}
      </Card>
    </BasePage>
  );
};

export default SearchResultsPage;
